export function setItem(type, value) {
    localStorage.setItem(type, JSON.stringify(value))
}

export function getItem(type) {
    let value = localStorage.getItem(type);
    value = value ? JSON.parse(value) : false;
    return value;
}